fx.ns("desktop.common.behaviour", class ComponentDragger extends fx.EventDispatcher{

    constructor(model, editor)
    {    
        super();

        this.model = model;
        this.creation = model.creation;
        this.editor = editor;

        // TODO : to check this out
        //if (this.editor)
        //    this.on("mousedown", this._onMouseDown, this.editor);

        this.on("blur", this._onMouseUp, window);

        this._draggData = {};

        // let's detect picture uploaded
        this.on("updated", this._onUpdated, this.creation.parentModel);
    }

    // If we are dragging a picture, and it's begin uploaded, once it's uploaded, it's ID is updated, so we have to update dragging image content propoerty
    _onUpdated(e)
    {
        if (!this._draggData)
            return;

        if ( e.action.type == "update" && e.action.model instanceof models.Photo )
        {
            if (e.action.previous.id == this._draggData.content)
                this._draggData.content = e.action.data.id;
        }
    }

    get book()
    {
        return this._book;
    }

    set book(val)
    {
        this._book = val;
    }

    get editor()
    {
        return this._editor;
    }

    set editor(val)
    {
        if (this._editor)
            this.off("mousedown", this._onMouseDown, this.editor);

        this._editor = val;

        if (this._editor)
            this.on("mousedown", this._onMouseDown, this.editor);
    }

   

    _onMouseDown(e)
    {
        if (e.which != 1) return;
        
        if (this._draggData && this._draggData.moveBackTimer)
            return;

        let element = fx.dom.parent(e.target, ".draggable");
        if ( element )
        {
            e.preventDefault()

            this._listen(true);

            fx.dom.css(element, {opacity : 0, transition : "transform 0.5s, opacity 0.25s"} );

            this._draggData.dragging = true;
            this._draggData.element = element;
            this._draggData.class = element.getAttribute("data-class");
            this._draggData.bgcolor = element.getAttribute("data-bgcolor");    
            this._draggData.behaviour = element.getAttribute("data-behaviour");

            if (this._draggData.class == "Text")
            {
                let text = this.model.texts.find({id : element.getAttribute("data-id")});
                this._draggData.content = text.content;
                this._draggData.contentid =  element.getAttribute("data-id");
            }
            else
                this._draggData.content =  element.getAttribute("data-id");

            

            let position = fx.dom.offset(element);
            let width = element.getAttribute("width") || fx.dom.width(element);
            let height = element.getAttribute("height") || fx.dom.height(element);
            
            this._draggData.startPosition = {x : position.left, y : position.top};
            this._draggData.draggedElement = element.cloneNode(true);
            fx.dom.addClass(this._draggData.draggedElement, "dragging");
            this._draggData.draggedElement.id = Utils.newID();
            this._draggData.position = {x : e.pageX, y : e.pageY};
            this._draggData.offset = {   
                offsetX : e.pageX - position.left,
                offsetY : e.pageY - position.top,
                width : width, 
                height : height,
                originalWidth : Number( element.getAttribute("data-width") || width),
                originalHeight : Number( element.getAttribute("data-height") || height),
            };

            this._draggData.ratio = this._draggData.offset.originalWidth ? (this._draggData.offset.originalWidth /  this._draggData.offset.originalHeight ) : 1;
            
            let xPos = position.left;
            let yPos = position.top;
            
            fx.dom.css(this._draggData.draggedElement, {"position" : "absolute",  
                                                        "cursor" : "grabbing", 
                                                        "opacity" : 1, 
                                                        "z-index" : 1, 
                                                        "transform":"translate3d(0px, 0px, 0px)",
                                                        "transform-origin" : "center",
                                                        "left" : xPos, 
                                                        "top" : yPos, 
                                                        "width" : width, 
                                                        "height" : height});

            document.body.appendChild( this._draggData.draggedElement );

           fx.set("dragging", true);
        }
    }

    _onMouseMove(e)
    {
        if (!this._draggData || !this._draggData.offset)
            return;

        let xPos = e.pageX - this._draggData.offset.offsetX;
        let yPos = e.pageY - this._draggData.offset.offsetY;
        let elts = fx.graphics.elementsFromPoint(e.pageX, e.pageY,2);
        let elements = [];
        
        for (let i = 0; i < elts.length; i++)
        {
            if (fx.dom.parent(elts[i], ".backcover"))
            {
                elements = [];
                break;
            }

            let element = fx.dom.parent(elts[i], "." + this._draggData.class);
            if (!element && fx.dom.hasClass(elts[i], "Stage") )
                element = elts[i];
            
            if (element && elements.indexOf(element) == -1)
                elements.push(element);
        }
        
        this._draggData.newPosition =  {left : xPos, top : yPos};

        if (elements.length == 0)
        {
            if (this._draggData.overPageComponent)
            {
                this._draggData.overPageComponent.event("drag-out"); 
                fx.dom.css(this._draggData.draggedElement, {opacity:1});
                this._draggData.overPageComponent = null;
            }

            this._draggData.overComponent = null;
            this._draggData.dropAllowed = false;
            this._draggData.area = null;
            this._draggData.page = null;
        }

        for (let i = 0; i < elements.length; i++)
        {
            let element = elements[i];
            if (element == this._draggData.draggedElement || fx.dom.parent(element, ".Frame"))
                continue;

            let area = fx.dom.parent(element, ".Stage") ? fx.dom.parent(element, ".Area") : null;
            
            //if (!area) continue;

            let areaDataId = area ? area.getAttribute("data-id") : null;
            this._draggData.area = area;
            this._draggData.scale = fx.graphics.getScale( this._draggData.area );
            this._draggData.page = areaDataId ? this.creation.getElement(areaDataId) : null;
          
            let component = fx.dom.parent(element, "." + this._draggData.class);
            let componentDataId = component ? component.getAttribute("data-id") : null;
            /*if(component)
            {
                if (component.className.includes("Text"))
                    componentDataId = component ? component.lastChild.getAttribute("data-id") : null;
            }*/
            
            if (this._draggData.overPageComponent && this._draggData.overPageComponent.id != componentDataId)
            {
                this._draggData.overPageComponent.event("drag-out"); 
                fx.dom.css(this._draggData.draggedElement, {opacity:1});
                this._draggData.overPageComponent = null;
                this._draggData.overComponent = null;
                this._draggData.dropAllowed = false;
            }

            if (this._draggData.page)
            {
                let pageComponent = componentDataId ? this._draggData.page.getComponent( componentDataId ) : null ;

                this._draggData.overPageComponent = pageComponent;
                this._draggData.overComponent = component;
                this._draggData.dropAllowed = component ? component.getAttribute("data-drop-allowed"): false;

                if (pageComponent) // drag over picture, show picture (sticker : no, background : yes, text : no)
                {
                    pageComponent.event("drag-over", {overcontent : this._draggData.content, draggedElement : this._draggData.draggedElement}); 
                    if (this._draggData.dropAllowed)
                        fx.dom.css(this._draggData.draggedElement, {opacity:0.4});

                    break;
                }                
            }  
             
        }
        
        if (this._draggData.page && !this._draggData.overPageComponent)
            this._draggData.newPosition.transform = "scale(" + Math.min(1.2, this._draggData.scale || 1.2) + ")"; // TODO : get scale of Area ?
        else
        {
            if (this._draggData.dropAllowed || !this._draggData.page)
             this._draggData.newPosition.transform = "scale(1)";
        }
            

        fx.dom.css(this._draggData.draggedElement, this._draggData.newPosition);
    }

    _onMouseUp(e)
    {
        if (this._draggData.dragging)
        {
            if (this._draggData.position.x != e.pageX &&  this._draggData.position.y != e.pageY)
            {
                //---- manage drop
                if (this._draggData.overPageComponent && this._draggData.overComponent.getAttribute("data-drop-allowed"))
                {
                    this._draggData.overPageComponent.event("drag-out"); 

                    if (this._draggData.overPageComponent.content != this._draggData.content || this._draggData.bgcolor)
                    {
                        let update = {content : this._draggData.content};
                        if (this._draggData.contentid)
                            update.contentid = this._draggData.contentid;

                        if (this._draggData.bgcolor)
                            update.bgcolor = this._draggData.bgcolor

                        this._draggData.overPageComponent.update("drop", update); 
                    }

                    this._draggData.moveBackTimer = this.delay(this._moveBack, 250);// setTimeout(this._moveBackHandler, 250);

                    fx.dom.css(this._draggData.draggedElement, {"transition" : "opacity 0.25s, transform 0.25s"});
                    fx.dom.css(this._draggData.draggedElement, {opacity:0, transform: "scale(0)"});

                }
                else
                if (this._draggData.page)
                {
                    let position = fx.dom.offset(this._draggData.area);
                    
                    let scale = fx.graphics.getScale( this._draggData.area );
                    let local = {
                                    x: Math.floor( e.pageX - position.left ) / scale,
                                    y: Math.floor( e.pageY - position.top ) / scale
                                };

                    let width, height, componentRatio = ((this._draggData.class == "Sticker" || this._draggData.class == "Shape") ? 0.3 : 0.8); 
                    if (this._draggData.offset.originalWidth > this._draggData.offset.originalHeight)
                    {
                        width = this.creation.pageWidth * componentRatio;
                        height = width / this._draggData.ratio;
                    }
                    else
                    {
                        height = this.creation.pageWidth * componentRatio;
                        width = height * this._draggData.ratio;
                    }
                    

                    let ratioX = (this._draggData.offset.offsetX) / this._draggData.offset.width;
                    let ratioY = (this._draggData.offset.offsetY) / this._draggData.offset.height;
    
                    let x = (local.x  - ( width * ratioX));
                    let y = (local.y - ( height * ratioY));

                    let side;
                    if (this._draggData.page.isCover)
                    {
                        if (local.x < this.creation.pageWidth)
                            side = "left";
                        else
                        if (local.x >= this.creation.pageWidth && local.x <= this.creation.pageWidth + this.creation.sliceWidth)
                            side = "center";
                        else
                            side = "right";
                    }
                    else
                        side = (local.x < this.creation.pageWidth) ? "left" : "right";
                    
                    x = x.multipleOf( fx.get("settings").precision );
                    y = y.multipleOf( fx.get("settings").precision );
                    width = width.multipleOf( fx.get("settings").precision );
                    height = height.multipleOf( fx.get("settings").precision );
                
                    this.creation.event(this._draggData.behaviour || "add-component", {    
                        //page : this._draggData.page,
                        content: this._draggData.content, 
                        contentid: this._draggData.contentid, 
                        bgcolor: this._draggData.bgcolor, 
                        component_type : this._draggData.class.toLowerCase(), 
                        x : x,
                        y : y,
                        width : width,
                        height : height,
                        side : side,
                        creation : "dropped",
                        area : this._draggData.area.getAttribute("data-id")
                    });

                    this._draggData.moveBackTimer = this.delay(this._moveBack, 0);
                }
                else
                {
                    this._draggData.moveBackTimer = this.delay(this._moveBack, 500);//setTimeout(this._moveBackHandler, 500);
                    

                    fx.dom.css(this._draggData.draggedElement, {"transition" : "top 0.5s ease-out, left 0.5s ease-out"});
                    
                    fx.dom.css(this._draggData.draggedElement, {left : this._draggData.startPosition.x, top : this._draggData.startPosition.y});   
                }
            }
            else
            {
                // if user click on a "clickable element", we sent event to book
                // so it can send it to active page
                
                if (this._draggData.behaviour)
                    this.creation.event(this._draggData.behaviour || "add-component", {    
                                                    content: this._draggData.content, 
                                                    contentid: this._draggData.contentid,
                                                    bgcolor: this._draggData.bgcolor, 
                                                    component_type : this._draggData.class.toLowerCase(),
                                                    creation : "manual"
                                                } );
                
                this._draggData.moveBackTimer = this.delay(this._moveBack, 0);
            }
                
            //---- stop dragging

            
            
        }
        
        this._listen(false);
    }

    _moveBack()
    {
        if (!this._draggData) return;

        if (this._draggData.element)
        {
            fx.dom.css(this._draggData.element, {transition : "transform 0.5s"} );
            fx.dom.css(this._draggData.element, {opacity: 1});
        }
        
        if (this._draggData.draggedElement && this._draggData.draggedElement.parentNode)
            this._draggData.draggedElement.parentNode.removeChild( this._draggData.draggedElement );

        this._draggData = {};

        fx.set("dragging", false);
    }

    _listen(val)
    {
        if (val)
        {
            this.on("mousemove", this._onMouseMove, window);
            this.on("mouseup", this._onMouseUp, window);
        }   
        else
        {
            this.off("mousemove", this._onMouseMove, window);
            this.off("mouseup", this._onMouseUp, window);
        }
    }


});